import React, { useState } from 'react';

import LottieView from 'lottie-react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { isNative } from 'utils/environment';

import { AnimationProps } from './types';

export const SuccessAnimation: React.FC<
  AnimationProps & {
    navigateToOrderConfirmation?: () => void;
  }
> = ({ width, height, navigateToOrderConfirmation }) => {
  const [redirected, setRedirected] = useState(false);

  const uri = useStaticLottieUri(StaticImages.PaymentSuccessLoader);

  if (!uri) {
    return null;
  }

  return (
    <LottieView
      source={{ uri }}
      autoPlay
      loop={false}
      style={
        isNative && {
          width,
          height,
          alignSelf: 'center',
        }
      }
      resizeMode="cover"
      enableMergePathsAndroidForKitKatAndAbove
      onAnimationFinish={() => {
        if (!redirected) {
          // for this animation in particular we need to wait a bit in order to allow to reproduce it as is a faster animation
          setTimeout(() => navigateToOrderConfirmation?.(), 2000);
          // this is needed to avoid calling the redirect and activity creation more than one time
          setRedirected(true);
        }
      }}
    />
  );
};
